import '../../../../styles/oa.scss';
import React, { useState, useEffect} from 'react';
import {Tabs,Badge} from 'antd-mobile';
import NoticeList from './noticeList';
import { unreadNumNotice} from '../../../../services/saas/oa';
import { getUser } from '../../../../utils';

function NotificationList(props) {
  let [noReadNum, setNoReadNum] = useState(0);
  const tabs = [
    { title: <Badge text={`${noReadNum>0?(noReadNum>99?'99+':noReadNum):''}`}>未读</Badge> },
    { title: <Badge>已读</Badge> },
  ];

  //待阅读消息数量
  const getUnReadNoticeNum = async function () {
  const { userId } = getUser();
    const param = {
      userId
    };

    const respActive = await unreadNumNotice(param);
    if (respActive&&respActive.success&&respActive.data) {
      setNoReadNum(respActive.data.ct);
    }
  };

  useEffect(()=>{
    getUnReadNoticeNum();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  },[])


  return (
    <div className=''>
      <Tabs tabs={tabs}
            initialPage={0}
            onChange={(tab, index) => { console.log('onChange', index, tab); }}
            onTabClick={(tab, index) => { console.log('onTabClick', index, tab); }}
            prerenderingSiblingsNumber={false}
      >
        <div style={{ height: '600px'}}>
          <NoticeList isRead={0}/>
        </div>
        <div style={{height: '600px'}}>
          <NoticeList isRead={1}/>
        </div>
      </Tabs>
    </div>
  );
}

export default NotificationList;

